

// import React, { CSSProperties } from 'react';


// const TermsAndConditions: React.FC = () => {
//   const openEmail = () => {
//     window.location.href = "mailto:support@instaship.co.in";
//   };

//   const sections = [
//     {
//       title: "1. Definitions",
//       bullets: [
//         "<b>GTA (Goods Transport Agency):</b> Registered agency providing transportation services. We facilitate vehicle hire through partner GTAs while acting as the transporter.",
//         "<b>Customer:</b> Any individual or business entity using our platform to book transportation services.",
//         "<b>Transport Partner:</b> Partner GTAs providing vehicle hire services through our platform.",
//         "<b>Consignment:</b> Goods transported as per booking request.",
//       ],
//     },
//     {
//       title: "2. Nature of Services",
//       bullets: [
//         "Logistics and transportation services",
//         "Vehicle sourcing from partner GTAs",
//         "Direct transportation contract with customers",
//       ],
//     },
//     {
//       title: "3. Booking and Service Fulfillment",
//       bullets: [
//         "Book through mobile app",
//         "Vehicle allocation from partner GTAs",
//         "Right to reject/cancel bookings",
//       ],
//     },
//     {
//       title: "4. Pricing and Payment",
//       bullets: [
//         "Distance, weight-based pricing",
//         "Full payment per invoicing terms",
//         "GST and taxes as per Indian regulations",
//       ],
//     },
//     {
//       title: "5. Liability and Limitations",
//       bullets: [
//         "Act as primary transporter",
//         "No liability for force majeure events",
//         "Accurate goods declaration required",
//         "24-hour damage claim window",
//       ],
//     },
//     {
//       title: "6. Cancellation and Refund",
//       bullets: [
//         "Full refund pre-dispatch",
//         "Charges apply post-dispatch",
//         "2–5 business day refund processing",
//       ],
//     },
//     {
//       title: "7. Dispute Resolution",
//       bullets: [
//         "Arbitration under Indian laws",
//         "Jurisdiction in Delhi courts",
//       ],
//     },
//     {
//       title: "8. Amendments",
//       bullets: ["Right to update terms"],
//       note: "By using our platform, you acknowledge reading and understanding these Terms.",
//     },
//   ];

//   return (
//     <div style={styles.container}>
//       {/* Header */}
//       <div style={styles.header}>
//         <span style={styles.headerIcon}>📄</span>
//         <div>
//           <h1 style={styles.title}>Terms & Conditions</h1>
//           <p style={styles.lastUpdated}>Last Updated: June 10, 2025</p>
//         </div>
//       </div>

//       {/* Content Sections */}
//       <div style={styles.sections}>
//         {sections.map((section) => (
//           <div key={section.title} style={styles.section}>
//             <h2 style={styles.sectionTitle}>{section.title}</h2>
//             <ul style={styles.bulletList}>
//               {section.bullets.map((bullet, index) => (
//                 <li
//                   key={index}
//                   dangerouslySetInnerHTML={{ __html: bullet }}
//                   style={styles.bullet}
//                 />
//               ))}
//             </ul>
//             {section.note && <p style={styles.note}>{section.note}</p>}
//           </div>
//         ))}
//       </div>




//     </div>
//   );
// };

// const styles: Record<string, CSSProperties> = {
//   container: {
//     maxWidth: '800px',
//     margin: '0 auto',
//     padding: '3rem 1.5rem',
//     color: '#333',
//     fontFamily: "'Inter', sans-serif",
//     backgroundColor: '#f9fafb',
//   },
//   header: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '1rem',
//     marginBottom: '2rem',
//   },
//   headerIcon: {
//     fontSize: '2rem',
//   },
//   title: {
//     fontSize: '2rem',
//     fontWeight: 700,
//     color: '#4169E1',
//     margin: 0,
//   },
//   lastUpdated: {
//     fontSize: '0.875rem',
//     color: '#666',
//     marginTop: '0.25rem',
//   },
//   sections: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '2rem',
//   },
//   section: {},
//   sectionTitle: {
//     fontSize: '1.25rem',
//     fontWeight: 600,
//     marginBottom: '0.5rem',
//   },
//   bulletList: {
//     paddingLeft: '1.2rem',
//     margin: 0,
//   },
//   bullet: {
//     marginBottom: '0.5rem',
//     lineHeight: '1.6',
//   },
//   note: {
//     marginTop: '0.5rem',
//     fontStyle: 'italic',
//     color: '#555',
//   },
//   contact: {
//     marginTop: '3rem',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.5rem',
//     backgroundColor: '#e6f0ff',
//     border: '1px solid #b3d1ff',
//     padding: '1rem',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     transition: 'background-color 0.2s',
//   },
//   contactIcon: {
//     fontSize: '1.25rem',
//   },
//   contactText: {
//     fontSize: '1rem',
//     color: '#4169E1',
//     fontWeight: 500,
//   },
// };

// export default TermsAndConditions;















import React, { CSSProperties, useEffect, useState } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Footer from '../components/Footer';

const TermsAndConditions: React.FC = () => {

    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 940);

    useEffect(() => {
        const handleResize = () => {
            //   setIsMobile(window.innerWidth < 768);
            setIsMobile(window.innerWidth < 940);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    // const sections = [

    //     {
    //         title: '1. Introduction',
    //         bullets: [
    //             ' Welcome to Instaship Logistics Private Limited ("Company," "we," "us," or "our"). We are committed to providing seamless and efficient transportation solutions. By using our services, you agree to these Terms and Conditions.'
    //         ],
    //     },
    //     {


    //         title: "2. Definitions",
    //         bullets: [
    //             "<b>GTA (Goods Transport Agency):</b> Registered agency providing transportation services. We facilitate vehicle hire through partner GTAs while acting as the transporter.",
    //             "<b>Customer:</b> Any individual or business entity using our platform to book transportation services.",
    //             "<b>Transport Partner:</b> Partner GTAs providing vehicle hire services through our platform.",
    //             "<b>Consignment:</b> Goods transported as per booking request.",
    //         ],
    //     },
    //     {
    //         title: "3. Nature of Services",
    //         bullets: [
    //             "Logistics and transportation services",
    //             "Vehicle sourcing from partner GTAs",
    //             "Direct transportation contract with customers",
    //         ],
    //     },
    //     {
    //         title: "4. Booking and Service Fulfillment",
    //         bullets: [
    //             "Book through mobile app",
    //             "Vehicle allocation from partner GTAs",
    //             "Right to reject/cancel bookings",
    //         ],
    //     },
    //     {
    //         title: "5. Pricing and Payment",
    //         bullets: [
    //             "Distance, weight-based pricing",
    //             "Full payment per invoicing terms",
    //             "GST and taxes as per Indian regulations",
    //         ],
    //     },
    //     {
    //         title: "6. Liability and Limitations",
    //         bullets: [
    //             "Act as primary transporter",
    //             "No liability for force majeure events",
    //             "Accurate goods declaration required",
    //             "24-hour damage claim window",
    //             "Maximum liability for loss, damage, or theft is limited to the lower of the declared value of the goods or ₹6000 per consignment.",
    //         ],
    //     },
    //     {
    //         title: "7. Cancellation and Refund",
    //         bullets: [
    //             "Full refund pre-dispatch",
    //             "Charges apply post-dispatch",
    //             "2–5 business day refund processing",
    //         ],
    //     },
    //     {
    //         title: "8. Dispute Resolution",
    //         bullets: [
    //             "Arbitration under Indian laws",
    //             "Jurisdiction in Delhi courts",
    //         ],
    //     },
    //     {
    //         title: "9. Amendments",
    //         bullets: ["Right to update terms"],
    //         note: "By using our platform, you acknowledge reading and understanding these Terms.",
    //     },
    // ];





    const sections = [
        {
          title: '1. Introduction',
          bullets: [
            'Welcome to Instaship Logistics Private Limited ("Company," "we," "us," or "our"). By using our services, you agree to the following Terms and Conditions designed to ensure efficient, transparent, and reliable transportation solutions.',
          ],
        },
        {
          title: '2. Definitions',
          bullets: [
            '<b>GTA (Goods Transport Agency):</b> A registered agency offering transportation services. We act as the transporter by facilitating vehicle arrangements through our partner GTAs.',
            '<b>Customer:</b> Any individual or business entity utilizing our platform to book transportation services.',
            '<b>Transport Partner:</b> A Goods Transport Agency affiliated with us for providing vehicle services.',
            '<b>Consignment:</b> Goods that are transported as part of a confirmed booking request.',
          ],
        },
        {
          title: '3. Nature of Services',
          bullets: [
            'We provide logistics and transportation solutions through our digital platform.',
            'Vehicles are sourced from our network of verified partner GTAs.',
            'Customers enter into a direct transportation agreement with us upon booking confirmation.',
          ],
        },
        {
          title: '4. Booking and Service Fulfillment',
          bullets: [
            'Bookings must be made through our mobile application.',
            'Vehicles are assigned based on availability from our partner network.',
            'We reserve the right to accept, reject, or cancel any booking at our discretion.',
          ],
        },
        {
          title: '5. Pricing and Payment',
          bullets: [
            'Pricing is determined based on distance, weight, and other service parameters.',
            'Full payment must be made according to the terms mentioned in the invoice.',
            'Applicable GST and other statutory taxes will be added as per Indian regulations.',
          ],
        },
        {
          title: '6. Liability and Limitations',
          bullets: [
            'We act as the primary transporter in each transaction.',
            'We are not liable for delays, losses, or damages caused by force majeure events.',
            'Customers are responsible for providing an accurate declaration of the goods being transported.',
            'Claims for damages must be raised within 24 hours of delivery.',
            'Our liability for any loss, damage, or theft is limited to the lesser of the declared value of the consignment or ₹6000 per shipment.',
          ],
        },
        {
          title: '7. Cancellation and Refund',
          bullets: [
            'Customers are eligible for a full refund if the booking is cancelled before vehicle dispatch.',
            'Partial charges may apply for cancellations made after dispatch.',
            'Refunds will be processed within 2–5 business days, subject to our refund policy.',
          ],
        },
        {
          title: '8. Dispute Resolution',
          bullets: [
            'All disputes will be resolved through arbitration in accordance with Indian laws.',
            'The courts of Delhi shall have exclusive jurisdiction over any legal matters arising from our services.',
          ],
        },
        {
          title: '9. Amendments',
          bullets: [
            'We reserve the right to modify these Terms and Conditions at any time. Updated terms will be communicated through appropriate channels.',
          ],
          note: 'By continuing to use our platform, you confirm that you have read, understood, and agreed to these Terms and Conditions.',
        },
      ];
      
    return (
        <>
            <div style={styles.container}>
                {/* Header */}
                <div style={styles.header}>
                    <span style={styles.headerIcon}>📄</span>
                    <div>
                        <h1
                            // style={styles.title}
                            style={{ ...styles.title, fontSize: isMobile ? '1.75rem' : '2.25rem' }}>Terms & Conditions</h1>
                        <p
                            // style={styles.lastUpdated}
                            style={{ ...styles.lastUpdated, fontSize: isMobile ? '0.75rem' : '0.875rem' }}>Last Updated: June 10, 2025</p>
                    </div>
                </div>

                {/* Divider */}
                <hr style={styles.divider} />

                {/* Sections */}
                <div style={styles.sections}>
                    {sections.map((section) => (
                        <div key={section.title} style={styles.card}>
                            <h2
                                //   style={styles.sectionTitle}
                                style={{ ...styles.sectionTitle, fontSize: isMobile ? '1rem' : '1.25rem' }}>{section.title}</h2>
                            <ul style={styles.bulletList}>
                                {section.bullets.map((bullet, index) => (
                                    <li
                                        key={index}
                                        dangerouslySetInnerHTML={{ __html: bullet }}
                                        // style={styles.bullet}
                                        style={{
                                            ...styles.bullet,
                                            fontSize: isMobile ? '0.85rem' : '0.95rem',
                                        }}
                                    />
                                ))}
                            </ul>
                            {section.note && <p
                                //    style={styles.note}
                                style={{ ...styles.note, fontSize: isMobile ? '0.85rem' : '0.95rem' }}>{section.note}</p>}
                        </div>
                    ))}
                </div>

                {/* Contact */}
                {/* <div onClick={openEmail} style={styles.contactCard}>
          <span style={styles.contactIcon}>📧</span>
          <div>
            <p style={styles.contactLabel}>Have questions?</p>
            <p style={styles.contactEmail}>support@instaship.co.in</p>
          </div>
        </div> */}
            </div>

        </>
    );
};

const styles: Record<string, CSSProperties> = {
    container: {
        maxWidth: '960px',
        margin: '0 auto',
        padding: '3rem 1.5rem',
        color: '#333',
        fontFamily: "'Inter', sans-serif",
        backgroundColor: '#f9fafb',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        marginBottom: '1.5rem',
    },
    headerIcon: {
        fontSize: '2.5rem',
    },
    title: {
        fontSize: '2.25rem',
        fontWeight: 800,
        color: '#4169E1',
        margin: 0,
    },
    lastUpdated: {
        fontSize: '0.875rem',
        color: '#666',
        marginTop: '0.25rem',
    },
    divider: {
        border: 0,
        height: '1px',
        backgroundColor: '#ddd',
        marginBottom: '2rem',
    },
    sections: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1.75rem',
    },
    card: {
        backgroundColor: '#ffffff',
        padding: '1.5rem',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    },
    sectionTitle: {
        fontSize: '1.25rem',
        fontWeight: 700,
        marginBottom: '0.75rem',
        color: '#1a1a1a',
    },
    bulletList: {
        paddingLeft: '1.2rem',
        margin: 0,
    },
    bullet: {
        marginBottom: '0.5rem',
        lineHeight: '1.6',
        fontSize: '0.95rem',
    },
    note: {
        marginTop: '0.75rem',
        fontStyle: 'italic',
        color: '#666',
    },
    contactCard: {
        marginTop: '3rem',
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        backgroundColor: '#ebf3ff',
        border: '1px solid #c9dfff',
        padding: '1.25rem 1.5rem',
        borderRadius: '10px',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
    },
    contactIcon: {
        fontSize: '1.5rem',
        color: '#4169E1',
    },
    contactLabel: {
        margin: 0,
        fontWeight: 500,
        fontSize: '0.9rem',
        color: '#333',
    },
    contactEmail: {
        margin: 0,
        fontWeight: 600,
        color: '#4169E1',
        fontSize: '1rem',
    },
};

export default TermsAndConditions;
